import script from "./FormulaDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulaDetails.vue?vue&type=script&setup=true&lang=js"

import "./FormulaDetails.vue?vue&type=style&index=0&id=04ba7a02&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ba7a02"]])

export default __exports__